import { IUserData } from '../../typings/user'
import axiosVerbose from './axios/axiosVerbose'

const userApiPath = '/shopfront-api/private/user'

export const acceptTermsAndConditionsRequest = (token: string) => {
  return axiosVerbose
    .post(
      `${userApiPath}/terms_accept`,
      {},
      {
        headers: {
          Authorization: `Bearer ${token}`
        }
      }
    )
    .then(res => res.data)
}

export const getUserProfileRequest = (token: string) => {
  return axiosVerbose
    .get<IUserData>(userApiPath, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    })
    .then(res => res.data)
}

export const getGuestCartRequest = () => {
  return axiosVerbose.get('/shopfront-api/cart')
}

export const addItemToUserCartRequest = (token: string, data: any) => {
  return axiosVerbose
    .post(`${userApiPath}/cart/entry`, data, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    })
    .then(res => res.data)
}

export const editUserCartEntryRequest = (
  token: string,
  entryID: number,
  data: any
) => {
  return axiosVerbose
    .put(`${userApiPath}/cart/entry/${entryID}`, data, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    })
    .then(res => res.data)
}

export const createUserCartRequest = (token: string) => {
  return axiosVerbose
    .post(
      `${userApiPath}/cart/`,
      {},
      {
        headers: {
          Authorization: `Bearer ${token}`
        }
      }
    )
    .then(res => res.data)
}

export const createGuestCartRequest = () =>
  axiosVerbose.post('/shopfront-api/cart/', {}).then(res => res.data)

export const addItemToGuestCartRequest = (data: any) => {
  return axiosVerbose
    .post(`/shopfront-api/cart/entry`, data)
    .then(res => res.data)
}

export const editGuestCartEntryRequest = (entryID: number, data: any) => {
  return axiosVerbose
    .put(`/shopfront-api/cart/entry/${entryID}`, data)
    .then(res => res.data)
}

export const getBookmarksForItemsRequest = (
  token: string,
  itemIds: number[]
) => {
  return axiosVerbose
    .get(`${userApiPath}/bookmarks_for_items?item_ids=${itemIds.join(',')}`, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    })
    .then(res => res.data)
}

export const deleteBookmarkRequest = (token: string, id: number) => {
  return axiosVerbose
    .delete(`${userApiPath}/bookmark/${id}`, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    })
    .then(res => res.data)
}

export const createBookmarkRequest = (
  token: string,
  collectionId: number,
  itemId: number
) => {
  return axiosVerbose
    .post(
      `${userApiPath}/collection/${collectionId}/bookmark`,
      {
        item_id: itemId
      },
      {
        headers: {
          Authorization: `Bearer ${token}`
        }
      }
    )
    .then(res => res.data)
}

export const createCollectionRequest = (
  token: string,
  {
    name,
    isPublic,
    description,
    specialRole
  }: {
    name: string
    isPublic: boolean
    description: string
    specialRole: string
  }
) => {
  return axiosVerbose
    .post(
      `${userApiPath}/collection`,
      {
        name,
        public: isPublic,
        description,
        specialRole
      },
      {
        headers: {
          Authorization: `Bearer ${token}`
        }
      }
    )
    .then(res => res.data)
}

/**
 * Converts a User Api Response to a user object,
 * a list of their collections with bookmarks nested,
 * @param  {Object} the api user response
 * @return {Object} a object with the users info, collections/bookmarks and favorites collection ID
 */
export const formatUserResponse = (userResponse: IUserData) => {
  try {
    const user = { ...userResponse }

    delete user.collections
    delete user.cart
    delete user.misc

    const collections = userResponse.collections
    let newCollections = {}

    if (collections) {
      newCollections = collections.reduce(
        (prev, collection) => {
          prev[collection.id] = collection
          prev[collection.id].bookmarks = {}
          return prev
        },
        {} as any
      )
    }

    return {
      profile: user,
      collections: newCollections,
      cart: userResponse.cart,
      misc: userResponse.misc
    }
  } catch (e) {
    // eslint-disable-next-line
    console.error('format user response error', e)
    return undefined
  }
}
